import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';

import { CollapseCheckbox } from '../components/collapseCheckbox';
import { TermostatstyringRadio } from '../components/termostatstyringRadio';
import { AboutFormControlProps, AboutFormData } from '../../types';
import { Termostatstyring } from '../../../../../utils/registerEnums';

export const Takvarme: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext<AboutFormData>();

  return (
    <Controller
      control={control}
      name="oppvarming.oppvarmingElektrisk.takvarme.selected"
      render={({ field: { value, onChange }, fieldState }) => (
        <CollapseCheckbox
          checked={!!value}
          onChange={(checked) => {
            onChange(checked);

            const newValue = checked ? { termostatstyring: Termostatstyring.Ukjent } : undefined;

            setValue('oppvarming.oppvarmingElektrisk.takvarme.value', newValue);
          }}
          error={!!fieldState.error}
          labelKey="register.tekniskUtstyr.takvarme.label"
          helperTextKey="register.tekniskUtstyr.takvarme.helperText"
        >
          <Controller
            control={control}
            name="oppvarming.oppvarmingElektrisk.takvarme.value.termostatstyring"
            render={({ field: { value, onChange }, fieldState }) => (
              <TermostatstyringRadio
                value={value}
                labelKey="register.tekniskUtstyr.takvarme.label"
                informationKey="register.tekniskUtstyr.takvarme.information"
                error={fieldState.error}
                onChange={onChange}
              />
            )}
          />
        </CollapseCheckbox>
      )}
    />
  );
};
